// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__33_RY","grow0":"Button_grow0__2FMlY","grow1":"Button_grow1__Fy3Wr"};